import actions from '../../actionTypes';

export default area => {
  return {
    type: actions.EDITED_AREA,
    area
  };
};



// WEBPACK FOOTER //
// ./src/reducers/areas/actions/editedArea.js